import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useAuth } from "../auth/AuthContext";
import BrandLogo from "./BrandLogo";
import "../styles/publicTheme.css";

const SiteHeader = () => {
  const { isAuthenticated, userAuthenticated, adminAuthenticated } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const close = () => setMenuOpen(false);

  return (
    <header className="landing-header">
      <div className="landing-header-inner">
        <Link to="/" className="landing-brand" onClick={close}>
          <BrandLogo height={34} />
        </Link>

        <button
          type="button"
          className="landing-menu-btn"
          aria-label="Menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <Icon icon={menuOpen ? "mdi:close" : "mdi:menu"} width={24} />
        </button>

        <nav className={`landing-nav ${menuOpen ? "is-open" : ""}`}>
          <Link to="/#how" onClick={close}>
            How it works
          </Link>
          <Link to="/#features" onClick={close}>
            Features
          </Link>
          <Link to="/pricing" onClick={close}>
            Pricing
          </Link>
          <Link to="/testimonials" onClick={close}>
            Testimonials
          </Link>
          <Link to="/faqs" onClick={close}>
            FAQ
          </Link>

          {isAuthenticated ? (
            <>
              {userAuthenticated ? (
                <Link className="landing-cta-btn" to="/dashboard" onClick={close}>
                  Dashboard
                </Link>
              ) : null}
              {adminAuthenticated ? (
                <Link
                  className={userAuthenticated ? "landing-nav-link" : "landing-cta-btn"}
                  to="/admin/dashboard"
                  onClick={close}
                >
                  Admin
                </Link>
              ) : null}
            </>
          ) : (
            <>
              <Link to="/login" onClick={close}>
                Login
              </Link>
              <Link className="landing-cta-btn" to="/register" onClick={close}>
                Get started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
